module.exports = __webpack_public_path__ + "static/media/PDF_119.cfd1dc62.pdf";